import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  Icon,
  IconButton,
  Paper,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,

} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import jwtDecode from "jwt-decode";
import { useTheme } from "@mui/material/styles";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Draggable from 'react-draggable';
function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"], button'}
      disabled={isMobile}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}
export default function BookingRequestDialog(props) {
  const {
    open,
    onClose,
    bookingContainer,
    handleSendBooking,
    bookingContent,
    bookingTitle,
    alreadyBookedContainer = [],
    bookingApiEndpoint,
    bookingComment,
    setBookingComment,
    btnDisableBooking,
    token,
  } = props;
  const [companyName, setCompanyName] = useState();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
    const users = async () => {
      if (token?.company) {
        const user = await OAuthService.getList(
          userUrl + `/search/findByCompanyId?companyId=${token?.company}`
        );
        const list = user?.data?._embedded?.users;
        const userInfo = list.find((item) => item?.email === token?.email);
        setCompanyName(userInfo?.companyName);
      }
    };
    users();
  }, []);
  const handleOnClose = useCallback(() => {
    onClose();
    setBookingComment("");
  }, [onClose]);

  return (
    <>
      <Dialog open={open} onClose={handleOnClose} fullWidth fullScreen={isMobile} maxWidth="sm" PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title">
        <AppBar position="static" color="secondary" sx={{ cursor: "move" }} id="draggable-dialog-title">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              {bookingTitle}
            </Typography>
            <IconButton onClick={handleOnClose} color="inherit">
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        {alreadyBookedContainer.length > 0 && (
          <DialogContent classes={{ root: "p-16 sm:p-24" }}>
            {bookingApiEndpoint === "approval"
              ? "Request Already Booked"
              : "Already requested for booking container"}
          </DialogContent>
        )}
        {bookingContainer.length > 0 && (
          <>
            {" "}
            <DialogContent classes={{ root: "p-16 sm:p-24" }}>
              <p>Dear Team,</p>
              {bookingContainer?.map((container) => (
                <p key={container.id} className="mt-2  pl-8">
                  {" "}
                  Container # : {container.containerNo}
                </p>
              ))}
              {bookingContent}
              <div className="flex flex-wrap mt-10">
                {bookingContainer.map((container) => (
                  <div
                    key={container.id}
                    className="widget flex w-full sm:w-1/2 md:w-1/2"
                  >
                    <Paper
                      sx={{
                        border: (theme) => `1px solid ${theme.palette.divider}`,
                      }}
                      width="100%"
                      wordBreak="break-word"
                      overFlowWrap="anywhere"
                      className="rounded-8 shadow-none mb-10 p-10"
                    >
                      <p>Container No: {container.containerNo}</p>
                      <p>Container Type: {container.containerType}</p>
                      <p>Destination: {container.destination}</p>
                      <p>Loading Week: {container.plannedLoadingWeek}</p>
                      <p>Total Orders: {container.totalOrders}</p>
                      <p>Total Volume: {container.orderTotalVolume}</p>
                      <p>Total Weight: {container.orderTotalWeight}</p>
                      <p>Product: {container.vendors.join(", ")}</p>
                      <p>Forwarder: {container.forwarderName}</p>
                    </Paper>
                  </div>
                ))}
              </div>
              <div className="mt-10">
                <TextField
                  id="outlined-textarea"
                  label="Comment"
                  placeholder="Write your comment here"
                  multiline
                  fullWidth
                  rows={2}
                  value={bookingComment}
                  onChange={(e) => setBookingComment(e.target.value)}
                />
              </div>
              <br />
              <p>Thanks & Regards</p>
              <br />
              {bookingApiEndpoint === "bookingToNfze" ? (
                <p>
                  {`${token?.name} ${token?.given_name}`.toUpperCase()}

                  <br />
                  <span className="mt-4 font-semibold">{companyName}</span>
                </p>
              ) : (
                <p>
                  Nolte FZE
                  <br />
                  Dubai Silicon Oasis HQ.
                  <br />
                  P.O. Box# 341265
                  <br />
                  Dubai, United Arab Emirates
                  <br />
                  Tel. +971 4 371 2675
                  <br />
                  Fax. +971 4 371 2676
                  <br />E Mail : orders@noltefze.com
                </p>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="contained"
                fullWidth={isMobile}
                startIcon={<FuseSvgIcon>material-solid:email</FuseSvgIcon>}
                onClick={handleSendBooking}
                disabled={btnDisableBooking}
              >
                Send
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
}
